import styled, { css } from 'styled-components';
import { Button } from '../Button';
import { TrevorIcon } from '../TrevorIcon';
import { CardProps } from './Card.types';
import React from 'react';
import { applyGap, applyMinHeight, applyPadding } from '../../utils';

export const CardContainer = styled.div<CardProps>`
  ${applyPadding};
  ${applyGap};
  ${applyMinHeight};
  width: ${(p) => p.width ?? 'fit-content'};
  height: fit-content;
  background: var(--color-interface-neutral-light);
  box-shadow: var(--elevation-soft);
  border-radius: var(--radius-16);
  position: relative;
  align-items: ${(p) => p.alignItems || 'inherit'};
  display: flex;
  flex-direction: column;
`;

export const CardExpandContainer = styled(CardContainer)`
  padding: unset;
`;

export const CardCloseButton = styled(Button).attrs({
  variant: 'secondary',
  icon: <TrevorIcon name="close" />,
})`
  position: absolute;
  align-self: end;
`;

export const CardExpandHeader = styled.div<CardProps>`
  ${applyPadding};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
`;

export const CardExpandBody = styled.div<CardProps>`
  ${applyPadding};
  ${applyGap};
  align-items: ${(p) => p.alignItems || 'inherit'};
  display: flex;
  flex-direction: column;
  padding-top: unset;
`;

export const CardExpandButtonIcon = styled(Button).attrs({
  variant: 'secondary',
  icon: <TrevorIcon name="chevron-down" />,
})<{ flip: boolean }>`
  transition-duration: var(--transition-fast);
  align-self: start;
}

${(p) =>
  p.flip &&
  css`
    transform: rotate(180deg);
  `}

;
`;

export const CardTitleWithIconContainer = styled.div`
  > h3 {
    margin-top: var(--spacing-l);
  }
`;
